export default __webpack_public_path__ + "static/media/slider_2.f49ed417.png";